import { Link } from 'react-router-dom';
import { genres } from '@/mocks/comics';

const genreIcons: Record<string, string> = {
  都市恋爱: 'ri-heart-3-line',
  奇幻战斗: 'ri-sword-line',
  校园魔幻: 'ri-magic-line',
  职场现实: 'ri-briefcase-4-line',
  末日生存: 'ri-flood-line',
  古风武侠: 'ri-ink-bottle-line',
  科幻恋爱: 'ri-robot-2-line',
  美食日常: 'ri-restaurant-2-line',
  科幻冒险: 'ri-rocket-2-line',
  灵异悬疑: 'ri-ghost-line',
  热血搞笑: 'ri-emotion-laugh-line',
  律政悬疑: 'ri-scales-3-line',
  运动热血: 'ri-trophy-line',
  推理日常: 'ri-search-eye-line',
  宫廷奇幻: 'ri-vip-crown-2-line',
};

export default function Genres() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-end justify-between">
          <div>
            <span className="flex items-center gap-2 text-sm font-semibold text-secondary-700">
              <i className="ri-layout-grid-line text-base" />
              分类导航
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">按喜好快速找漫</h2>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {genres.map((g) => (
            <Link
              key={g}
              to={`/ranking/popularity?genre=${encodeURIComponent(g)}`}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-300 hover:bg-background-50"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className={`${genreIcons[g] ?? 'ri-book-2-line'} text-lg`} />
              </span>
              <span className="text-sm font-medium text-foreground-800">{g}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}